import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments, faEnvelope, faHeartPulse, faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';

import { QUESTION_CHAT_URL, QUESTION_FEEDBACK_FORM_URL } from '../../../../config/links';
import { Reveal } from '../../../../components/Reveal/Reveal';
import { SectionHeader } from '../../../../components/SectionHeader/SectionHeader';

import ui from '../../../../styles/ui.module.css';
import st from './Question.module.css';

export function Question() {
  return (
    <section className={`${ui.section} ${ui.sectionSeam} ${st.root}`}>
      <div className={ui.container}>
        <Reveal>
          <SectionHeader
            kicker="Связаться"
            title="Задать вопрос"
            subtitle="Приглашаем к сотрудничеству: вендоров и органы управления здравоохранения субъектов Российской Федерации."
          />
        </Reveal>

        <div className={st.contact}>
          <Reveal delay={0.05}>
            <div className={`${ui.card} ${st.infoCard}`}>
              <div className={st.infoTitle}>Контакты</div>
              <div className={st.items}>
                <div className={st.item}>
                  <FontAwesomeIcon icon={faPhone} />
                  <a href="tel:+74954342266">+7 (495) 434-22-66, доп. 20-15</a>
                </div>
                <div className={st.item}>
                  <FontAwesomeIcon icon={faEnvelope} />
                  <a href="mailto:support-aiedu@rsmu.ru">support-aiedu@rsmu.ru</a>
                </div>
                <div className={st.item}>
                  <FontAwesomeIcon icon={faLocationDot} />
                  <span>Онлайн</span>
                </div>
              </div>

              <div className={st.actions}>
                <a className={`${ui.btn} ${ui.btnGhost}`} href={QUESTION_CHAT_URL} target="_blank" rel="noreferrer">
                  Написать в чат <FontAwesomeIcon icon={faComments} />
                </a>
                <div className={st.actionsHint}>Или напишите нам в MAX!</div>
              </div>

              <div className={st.note}>
                <FontAwesomeIcon icon={faHeartPulse} /> Часы работы 10:00-18:00
              </div>
            </div>
          </Reveal>

          <Reveal>
            <div className={`${ui.card} ${st.formCard}`}>
              <div className={st.formLead}>
                Приглашаем вендоров и органы управления здравоохранения субъектов Российской Федерации для проведения мероприятий
                по обучающей программе «AI в здравоохранении» в очном и сетевом формате.
              </div>
              <div className={st.formText}>Просим заполнить форму обратной связи:</div>

              <div className={st.formActions}>
                <a className={ui.btn} href={QUESTION_FEEDBACK_FORM_URL} target="_blank" rel="noreferrer">
                  Заполнить форму <FontAwesomeIcon icon={faEnvelope} />
                </a>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

